import { useMutation, useQueryClient } from "@tanstack/vue-query";
import { handleClientMethod } from "@saflib/sdk";
import { getClient } from "../../client.ts";

export const useRemovePartSource = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: async (id: string) => {
      return handleClientMethod(
        getClient().DELETE("/part-sources/{id}", {
          params: { path: { id } },
        }),
      );
    },
    onSuccess: () => {
      // Invalidate part-source related queries after successful deletion
      queryClient.invalidateQueries({ queryKey: ["part-sources"] });
      // Invalidate parts list queries since deleting a CSV source affects parts data
      queryClient.invalidateQueries({ queryKey: ["parts", "list"] });
    },
  });
};
